// @mui
import { useTheme } from '@mui/material/styles';
import { Button } from '@mui/material';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// theme
import { bgBlur } from 'src/theme/css';
// components
import Iconify from 'src/components/iconify';
import { useSettingsContext } from 'src/components/settings';
import MenuIcon from 'src/assets/icons/menu';

// ----------------------------------------------------------------------

export default function NavToggleButton({ sx, ...other }: IconButtonProps) {
  const theme = useTheme();

  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  if (!lgUp) {
    return null;
  }

  return (
    // <Button
    //   variant="soft"
    //   onClick={() =>
    //     settings.onUpdate('themeLayout', settings.themeLayout === 'vertical' ? 'mini' : 'vertical')
    //   }
    //   sx={{
    //     minWidth: '45px',
    //     width: '45px',
    //     height: '45px',
    //   }}
    // >
      <MenuIcon
        style={{ cursor: "pointer", width: 43 }}
        onClick={() =>
          settings.onUpdate('themeLayout', settings.themeLayout === 'vertical' ? 'mini' : 'vertical')
        } 
      />
    // </Button>
  );
}
